<template>
  <v-container
    grid-list-md
    justify-start
    fluid
  >
    <v-layout row>
      <home-item-title>
        {{ $t("home.recent") }}
      </home-item-title>
    </v-layout>
    <v-layout row>
      <v-container
        grid-list-md
        justify-start
        fluid
        class="pa-0"
      >
        <v-layout
          row
          wrap
        >
          <template v-for="(project, index) in histProjects">
            <projects-grid-item
              :key="index"
              :project-data="project"
              :thumb="require('../../assets/icon/project.png')"
              @openProject="openProject"
            >
              {{ project.projectName }}
            </projects-grid-item>
          </template>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
// Components
import homeItemTitle from "./HomeItemTitle";
import projectsGridItem from "./ProjectsGridItem";

// Connectors
import { ProfileFavouriteConnector } from "../Database/ProfileFavouriteConnector.js";
import { ProjectConnector } from "../Database/ProjectConnector.js";

// Tools
const pathInfo = require("path");
const ft = require("../Tools/FileTools");

export default {
  components: {
    homeItemTitle,
    projectsGridItem,
  },
  data() {
    return {
      profileFavouriteConnector: new ProfileFavouriteConnector(this.$store.state.user),
      projectConnector: new ProjectConnector(this.$store.state.user),
      histProjects: [],
    };
  },
  created() {
    if (this.$store.state.user.socId != null) {
      this.getHistProjects();
    }
  },
  methods: {
    // TODO: Triple declaration of checkExistProject method
    checkExistProject(element) {
      return new Promise(async (resolve, reject) => {
        const exist = await ft.exists("./" + element.path).catch((err) => {
          console.error(err);
          return reject(err);
        });

        if (exist) {
          return resolve(this.createObject(element));
        } else {
          // Add flag notfound on project
          let path = element.path;

          if (path.indexOf("./") == 0) {
            path = path.slice(2, path.length);
          }

          // TODO: Why not using project id instead of path ?
          this.projectConnector.addFlagNotfound(path);
          return reject("Project not found");
        }
      });
    },
    createObject(element) {
      let id_proj = element.id_proj;

      if (id_proj === undefined) {
        id_proj = element.proj_id;
      }

      // GET BASENAME WITHOUT EXTENSION
      const filename = pathInfo.basename(element.path, ".zip");

      const project = {
        projectName: filename,
        savePath: element.path,
        projId: id_proj,
      };

      return project;
    },
    getHistProjects() {
      const promises = [];
      this.profileFavouriteConnector
        .getHistProjects(6)
        .then((projects) => {
          for (const project of projects) {
            promises.push(
              this.checkExistProject(project).catch((err) => {
                console.warn(err);
                return null;
              })
            );
          }

          Promise.all(promises)
            .then((result) => {
              // Filter results to remove null values
              this.histProjects = result.filter((element) => {
                if (element) return element;
              });
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openProject(projectData) {
      this.profileFavouriteConnector.insertHistProjectByFilepath(projectData.savePath);
      this.$emit("openProject", projectData);
    },
  },
};
</script>

<style></style>
